// extracted by mini-css-extract-plugin
export default {"container":"ActiveMedicationSection_container__8cKA-","renewalTag":"ActiveMedicationSection_renewalTag__pnx90","expired":"ActiveMedicationSection_expired__MW6+M"};